module.exports = __webpack_public_path__ + "assets/img/extra-notice.dc8c3a00.jpg";